import React__default from 'react';
import { useProductViewHistory } from './use-product-view-history.js';

const useAddToProductViewHistory = ({ variant , variants  })=>{
    const productViewHistory = useProductViewHistory();
    React__default.useEffect(()=>{
        productViewHistory.remove(variants.map((v)=>v.sku || ''
        ));
        productViewHistory.add(variant.sku);
    // Only add the product to the history on the initial load
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export { useAddToProductViewHistory };
//# sourceMappingURL=use-add-to-product-view-history.js.map
